import { createAsyncThunk } from '@reduxjs/toolkit';

import { UserProfile } from 'entities/User';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const fetchUser = createAsyncThunk<
    UserProfile,
    void,
    ThunkConfig<string>
>('user/fetchUser', async (_, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<UserProfile>(`/v1/users/me`);

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
